import * as types from '../../action-types';
import {getAllEmployments as initialState } from "../../initialState";

const getAllEmployments = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_EMPLOYMENTS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_ALL_EMPLOYMENTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_ALL_EMPLOYMENTS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_ALL_EMPLOYMENTS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getAllEmployments;
